<template>
<div class="test-editor" v-if="item.media">
  <h3>Test questions</h3>
  <ul class="type-chooser">
    <li :class="{active: item.testqs.type=='independent'}" v-on:click="item.testqs.type='independent'">Independent</li>
    <li :class="{active: item.testqs.type=='interactive'}" v-on:click="item.testqs.type='interactive'">Interactive</li>
  </ul>
  <div v-if="item.testqs.type=='independent'">
    <div class="field">
      <label>Access password</label>
      <input v-model="item.password" />
      <button v-on:click.prevent="generatePassword">Generate</button>
    </div>
    <div class="field">
      <label>Required correct</label>
      <input v-model="item.testqs.independent.passingScore" />
    </div>
    <ul class="questions">
      <li v-for="(question, qi) in item.testqs.independent.questions">
        <div class="field">
          <label>Question #{{qi+1}}:</label>
          <textarea v-model="question.text"></textarea>
        </div>
        <div class="field">
          <label>Answers:</label>
          <ul class="answers">
            <li v-for="(answer, ai) in question.answers">
              <input type="checkbox" v-model="answer.valid" />
              <input v-model="answer.text" />
              <a class="remove" href="" v-on:click.prevent="question.answers.splice(ai, 1)">&times;</a>
            </li>
            <li class="new">
              <a href="" v-on:click.prevent="question.answers.push({valid: false, text: ''})">+</a>
            </li>
          </ul>
        </div>
        <a class="remove" href="" v-on:click.prevent="item.testqs.independent.questions.splice(qi, 1)">&times;</a>
      </li>
      <li class="new">
        <a href="" v-on:click.prevent="item.testqs.independent.questions.push({text: '', answers: []})">+</a>
      </li>
    </ul>
  </div>
  <div v-if="item.testqs.type=='interactive'">
    <div class="field">
      <label>Access password</label>
      <input v-model="item.password" />
      <button v-on:click.prevent="generatePassword">Generate</button>
    </div>
    <ul class="chapters" v-if="item.chapters">
      <li v-for="(chapter, ci) in item.chapters"><template v-for="intv in [item.testqs.interactive[ci]]">
        <span class="time-range">
          <span class="start-time">{{ formatTime(chapter.time) }}</span>
          <span class="end-time">{{ formatTime(endTime(ci)) }}</span>
          <span class="chapter-title">{{ chapter.title }}</span>
        </span>
        <div class="field">
          <label>Required correct</label>
          <input v-model="intv.passingScore" />
        </div>
        <ul class="questions">
          <li v-for="(question, qi) in intv.questions">
            <div class="field">
              <label>Question:</label>
              <textarea v-model="question.text"></textarea>
            </div>
            <div class="field">
              <label>Answers:</label>
              <ul class="answers">
                <li v-for="(answer, ai) in question.answers">
                  <input type="checkbox" v-model="answer.valid" />
                  <input v-model="answer.text" />
                  <a class="remove" href="" v-on:click.prevent="question.answers.splice(ai, 1)">&times;</a>
                </li>
                <li class="new">
                  <a href="" v-on:click.prevent="question.answers.push({valid: false, text: ''})">+</a>
                </li>
              </ul>
            </div>
            <a class="remove" href="" v-on:click.prevent="intv.questions.splice(qi, 1)">&times;</a>
          </li>
          <li class="new">
            <a href="" v-on:click.prevent="intv.questions.push({text: '', answers: []})">+</a>
          </li>
        </ul>
      </template></li>
    </ul>

  </div>
</div>
</template>

<script>
export default {
  props: ["item"],
  data: ()=>({
  }),
  created() {
    if (!this.item.testqs)
      this.$set(this.item, "testqs", {type: 'independent'});
    if (!this.item.testqs.independent)
      this.$set(this.item.testqs, "independent", {
        passingScore: 0,
        questions: [],
      });
    var interactive=[];
    for(var i in this.item.chapters) {
      if (!interactive[i])
        interactive[i]={
          passingScore: 0,
          questions: [],
        };
    }
    if (!this.item.testqs.interactive)
      this.$set(this.item.testqs, "interactive", interactive);
  },
  methods: {
    generatePassword() {
      var password="";
      var chars="1234567890abcdefghklmnpqrstuvwxyz";
      for(var i=0;i<5;i++) {
        password+=chars[Math.floor(Math.random()*chars.length)];
      }
      this.item.password=password;
    },
    formatTime(time) {
      var m=Math.floor(time/60);
      var s=Math.floor(time%60);
      return (m<10?'0':'')+m+":"+(s<10?'0':'')+s;
    },
    endTime(chapterIndex) {
      if (!this.item.chapters || chapterIndex>=this.item.chapters.length-1)
        return this.$parent.duration;
      else
        return this.item.chapters[chapterIndex+1].time;
    },
  },
}
</script>
